import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from './app-settings';
import 'rxjs/add/operator/map';

import { StorageService } from './storage.service';
import { HttpService } from './http.service';

@Injectable()
export class AuthenticationService {

    constructor(
        private http: HttpService,
        private storage: StorageService,
        //private user:UserService
    ) { }

    login(user: any) {
        return this.http.post(AppSettings.API_LOGIN, user)
            .map((r: Response) => {
                let u = r.json();
                if (u && u.Token) {
                    this.storage.set(AppSettings.STORAGE_NAME, JSON.stringify({ LOGIN: u.UserName, DATA: u.Data }));
                    this.storage.set(AppSettings.TOKEN, u.Token);
                }
                return r.json();
            });
    }

    changePassword(user: any) {
        return this.http.post(AppSettings.API_CHANGE_PASSWORD, user)
            .map((r: Response) => {
                let u = r.json();
                if (u && u.Token) {
                    this.storage.set(AppSettings.STORAGE_NAME, JSON.stringify({ LOGIN: u.UserName, DATA: u.Data }));
                    this.storage.set(AppSettings.TOKEN, u.Token);
                }
                return r.json();
            });
    }

    olvidoContrasenia(user: any) {
        return this.http.post(AppSettings.API_OLVIDO_CONTRASENIA, user)
            .map((r: Response) => {
                return r.json();
            });
    }

    codigoContrasenia(request: any): Observable<any> {
        return this.http.get(AppSettings.API_CODIGO_CONTRASENIA, { params: request })
            .map((r: Response): any => {
                return r.json();
            });
    }

    logout() {
        this.storage.remove(AppSettings.STORAGE_NAME);
        this.storage.remove(AppSettings.TOKEN);
    }

    isAuthenticated() {
        return (this.storage.get(AppSettings.STORAGE_NAME) != null && this.storage.get(AppSettings.TOKEN) != null)
    }

}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/authentication.service.ts